<template>
  <div v-bind:class="{modal_open: isModalOpen}" class="your-dealer">
    <span class="icon icon-stihl-map-marker-1"></span>
    <span @click="trackModalEvent(); toggleModal()" class="dealer-name">{{dealerName}}</span>
    <ToggleIcon class="toggle-icon" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ToggleIcon from "@/components/ToggleIcon";

export default {
  name: 'YourDealer',
  props: {
    dealerName: {
      type: String
    }
  },
  computed: {
    ...mapGetters('DealerHeader', [
      'isModalOpen'
    ])
  },
  methods: {
    ...mapActions('DealerHeader', [
      'toggleModal'
    ]),
    trackModalEvent() {
      if (this.isModalOpen) {
         this.$dataLayer.push({ event: "pcedh.header-closed" })
      } else {
        this.$dataLayer.push({ event: "pcedh.header-opened" })
      }
    }
  },
  components: {
    ToggleIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .your-dealer {
    font-family: $font-title;
    overflow: hidden;
    min-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: default;
    .dealer-name {
      cursor: pointer;
      margin-right: 6px;
    }
    .icon {
      font-family: $font-icons;
      vertical-align: middle;
      margin-right: 6px;
    }
    @media screen and (max-width: $breakpoint-md) {
      .toggle-icon {
        display: none;
      }
    }
  }
</style>